<template>
	<div>
		<br/>
		<v-row
			class="mx-6"
		>
			<v-col
				cols="12"
				md="4"
				align-self="center"
				class="mt-md-12 pt-md-12"
			>
				<v-card
					shaped
					class="shrink"
					elevation="24"
				>
					<v-img
						height="33vh"
						:src="require('@/assets/location.png')"
					/>
				</v-card>
			</v-col>
			<v-col class="text-center ml-md-12">
				<br/>
				<p>
					Savannah and Jacob are tying the knot!
				</p>
				<p>
					Please join them on their special day on September 1<sup>st</sup>, 2023
				</p>
				<br/>
				<br v-if="!$vuetify.breakpoint.mobile"/>
				<v-row
					class="info-wrapper top-border"
				>
					<v-col
						cols="12"
						md="6"
						:class="isFalse($vuetify.breakpoint.mobile, 'right-border',)"
					>
						<h1>
							Wedding
						</h1>
						<br/>
						<p class="text-center">
							The ceremony will be held at the Cherry Creek Golf Club.
						</p>
						<br/>
						<p>
							Doors open at 4:00pm.
						</p>
						<p>
							Ceremony begins at 4:30pm.
						</p>
						<p>
							Cocktail hour will follow the ceremony.
						</p>
						<p>
							Dinner will be served at 6:00pm.
						</p>
					</v-col>
					<v-col
						cols="12"
						md="6"
						class="pl-md-12"
						:class="isTrue($vuetify.breakpoint.mobile, 'top-border')"
					>
						<h1>
							Location
						</h1>
						<br/>
						<p>
							Cherry Creek Golf Club is located off of 24 Mile Road, just west of Van Dyke Freeway.
						</p>
						<br/>
						<p>
							52000 Cherry Creek Dr<br/>
							Shelby Township, MI 48316
						</p>
						<br/>
						<p>
							Valet parking is provided.
						</p>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
		<br/>
		<br/>
	</div>
</template>

<script>
	const {isFalse, isTrue} = require("chorecore")

	export default {
		name: "Info",
		methods: {isFalse, isTrue}
	}
</script>

<style scoped>
	.info-wrapper p {
		text-align: left;
	}

	.top-border {
		border-top: 10px solid;
		border-image-slice: 1;
		border-top-width: 1px;
		border-image-source: linear-gradient(to right, white, var(--v-primary-lighten1), var(--v-primary-base),var(--v-primary-lighten1), white);
	}

	.right-border {
		border-right: 10px solid;
		border-image-slice: 1;
		border-right-width: 1px;
		border-image-source: linear-gradient(0deg, white, var(--v-primary-lighten1), var(--v-primary-base));
	}
</style>
